import { render } from "./LoginCallback.vue?vue&type=template&id=7469623a"
import script from "./LoginCallback.vue?vue&type=script&lang=js"
export * from "./LoginCallback.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2417804180/src/evpay-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__